(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("antd"), require("React"), require("loadjs"), require("ecCom"), require("$"), require("jQuery"), require("ReactDOM"));
	else if(typeof define === 'function' && define.amd)
		define(["antd", "React", "loadjs", "ecCom", "$", "jQuery", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["ecCom"] = factory(require("antd"), require("React"), require("loadjs"), require("ecCom"), require("$"), require("jQuery"), require("ReactDOM"));
	else
		root["ecCom"] = factory(root["antd"], root["React"], root["loadjs"], root["ecCom"], root["$"], root["jQuery"], root["ReactDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_51__, __WEBPACK_EXTERNAL_MODULE_539__, __WEBPACK_EXTERNAL_MODULE_57__, __WEBPACK_EXTERNAL_MODULE_339__, __WEBPACK_EXTERNAL_MODULE_61__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition